export default "__VITE_ASSET__BDS66a3X__"